// import React from "react";
// import { motion } from "framer-motion";
// import { AppWrap } from "../../wrapper";
// import MotionWrap from "../../wrapper/MotionWrap";

// import { ServicesData } from "../../constants/services";

// import "./About.scss";

// const About = () => {
//   return (
//     <>
//       <h2 className="head-text">
//         Digital Product <span>Creation</span> & <br />
//         Software Engineering <span>Education</span>
//       </h2>
//       <div className="app__profiles">
//         {ServicesData.map(([servicesDataKey, servicesDataValue]) => (
//           <motion.div
//             whileInView={{ opacity: 1 }}
//             whileHover={{ scale: 1.1 }}
//             transition={{ duration: 0.5, type: "tween" }}
//             className="app__profile-item"
//             key={servicesDataKey}
//           >
//             <div className="services-image-container">
//               <img src={servicesDataValue.img} alt={servicesDataValue.title} />
//             </div>
//             <h4 style={{ marginTop: 20, textAlign: "center" }}>
//               {servicesDataValue.title}
//             </h4>
//             <p
//               className="services-p-text"
//               style={{ marginTop: 10, textAlign: "center" }}
//             >
//               {servicesDataValue.description}
//             </p>
//           </motion.div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(About, "app__about"),
//   "about",
//   "app__whitebg"
// );

// import React from "react";
// import { motion } from "framer-motion";
// import { AppWrap } from "../../wrapper";
// import MotionWrap from "../../wrapper/MotionWrap";

// import { ServicesData } from "../../constants/services";

// import "./About.scss";

// const About = () => {
//   return (
//     <>
//       <h2 className="head-text">
//         Digital Product <span>Creation</span> & <br />
//         Software Engineering <span>Education</span>
//       </h2>
//       <div className="app__profiles">
//         {ServicesData.map(([key, service]) => (
//           <motion.div
//             key={key}
//             whileInView={{ opacity: 1 }}
//             whileHover={{ scale: 1.05 }}
//             transition={{ duration: 0.5, type: "tween" }}
//             className="app__profile-item"
//           >
//             <div className="services-image-container">
//               <img src={service.img} alt={service.title} />
//             </div>
//             <h4>{service.title}</h4>
//             <p className="services-p-text">{service.description}</p>
//           </motion.div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(About, "app__about"),
//   "about",
//   "app__whitebg",
// );

import React from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";
import MotionWrap from "../../wrapper/MotionWrap";

// Import icons from lucide-react
import { Server, Monitor, BookOpen, Briefcase } from "lucide-react";

import "./About.scss";

const servicesData = [
  {
    icon: Server,
    title: "Backend Development & Cloud Computing",
    description: (
      <>
        <span>Building</span>, <span>securing</span>, <span>optimising</span>{" "}
        and <span>scaling</span> digital services, systems and data that support
        your business operations and customer interaction in the{" "}
        <span>cloud</span>.
      </>
    ),
  },
  {
    icon: Monitor,
    title: "Frontend Development, Mobile Apps, Kiosks",
    description: (
      <>
        <span>Creating</span> engaging, aesthetic, and responsive{" "}
        <span>interfaces</span> your customers enjoy on <span>websites</span>,{" "}
        <span>mobile apps</span>, <span>kiosks</span> or{" "}
        <span>touchscreens</span>.
      </>
    ),
  },
  {
    icon: BookOpen,
    title: "Mentoring, Teaching, Training & Coaching",
    description: (
      <>
        <span>Empowering</span> you with the <span>skills</span> and{" "}
        <span>mindset</span> needed to thrive in your career or
        entrepreneurship, whether technical or business minded.
      </>
    ),
  },
  {
    icon: Briefcase,
    title: "Propositions, Pitching, Presales Consultation",
    description: (
      <>
        <span>Helping</span> organisations increase <span>revenue</span> by
        collaborating with sales, tech and marketing teams to <span>pitch</span>
        , <span>launch</span> and <span>position</span> digital products and
        services.
      </>
    ),
  },
];

const About = () => {
  return (
    <>
      {/* <h2 className="head-text">
        Digital Product <span>Creation</span> & <br />
        Software Engineering <span>Education</span>
      </h2> */}
      <h2 className="head-text">
        <span>Digital Product</span> Creation & <br />
        <span>Software Engineering</span> Education
      </h2>

      <div className="app__profiles">
        {servicesData.map((service, index) => {
          const Icon = service.icon;
          return (
            <motion.div
              key={index}
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5, type: "tween" }}
              className="app__profile-item"
            >
              <div className="services-icon-container">
                <Icon size={60} strokeWidth={1.5} className="services-icon" />
              </div>
              <h4>{service.title}</h4>
              <p className="services-description">{service.description}</p>
            </motion.div>
          );
        })}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg",
);
